// extracted by mini-css-extract-plugin
export var legendIndicator = "_8a-1";
export var legendRight = "_8a-0";